export default __webpack_public_path__ + "static/media/infosil.0039a8d8.jpg";